import {
  createCheckInFlight,
  MockCheckInFlight,
} from '@dapi/sdk/spec';

export const checkInFlight: MockCheckInFlight = createCheckInFlight();
